import { Badge, Divider, Drawer, IconButton, List, ListItemIcon, ListItemText, ListItemButton } from "@mui/material";
import React, { Fragment, useContext, useEffect, useState } from "react";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { SessionContext } from "../../../../utility/useSession";
import { api, IAlertNotificationList } from "../../../../logic/api";
import { WarningOutlined } from "@mui/icons-material";

import { useHistory } from "react-router-dom";
import AutoRefresh from "../../../../utility/autoRefresh";
import { FiSun } from "react-icons/fi";
import usePaths from "../../../../utility/paths";

const AlertsView = () => {
    const paths = usePaths();
    const session = useContext(SessionContext);
    const listAlerts = api.hooks.alerts.list();
    const history = useHistory();

    const [showDrawer, setShowDrawer] = useState(false);
    const [alertsData, setAlertsData] = useState<IAlertNotificationList | null>(null);
    const [lastAlertCount, setLastAlertCount] = useState<number>(-1);

    const refreshData = () => {
        listAlerts.send(session.current.context, {});
    }
    useEffect(() => {
        refreshData();
    }, []);

    useEffect(() => {
        if (listAlerts.data != null) {
            setAlertsData(listAlerts.data);
            if (lastAlertCount == 0 && listAlerts.data.items.length > 0 && showDrawer == false) {
                setShowDrawer(true);
            }
            setLastAlertCount(listAlerts.data.items.length);
        }
    }, [listAlerts.data]);

    let badgeCount = 0;
    const alertsBadgeLimit = 999;

    if (alertsData != null) {
        badgeCount = alertsData.total;
    }

    return (
        <>
            <AutoRefresh showUI={false} durationSeconds={3600} default={true} onRefresh={() => {
                refreshData();
            }} />
            <IconButton
                onClick={() => {
                    setShowDrawer(true);
                }}>
                <Badge max={alertsBadgeLimit} badgeContent={badgeCount} color="secondary" showZero>
                    <NotificationsIcon></NotificationsIcon>
                </Badge>
            </IconButton>
            <Drawer anchor={'right'} open={showDrawer} onClose={() => {
                setShowDrawer(false);
            }}>
                <div style={{ paddingLeft: 20, paddingRight: 20, paddingBottom: 20, minWidth: 300 }}>
                    <h1 style={{ fontWeight: 400 }}>Notifications</h1>
                </div>

                {alertsData != null && (
                    <List>

                        {alertsData.items.length == 0 && (
                            <div style={{ textAlign: "center" }}>
                                <div style={{ marginTop: 50 }}>
                                    <FiSun color="orange" size={60}></FiSun>
                                </div>
                                <h2 style={{ marginBottom: 0 }}>Clear Skies ahead.</h2>
                                <div>
                                    <small>{`You're completey up to date.`}</small>
                                </div>
                            </div>
                        )}



                        {alertsData.items.map((item, index) => (
                            <Fragment key={index}>
                                <ListItemButton
                                    onClick={() => {
                                        if (session.current?.site?.preferences.reports_v2 == true) {
                                            history.push(paths.reportV2View(item.reportId.toString(), true));
                                        } else {
                                            history.push(paths.reportView(item.reportId.toString()));
                                        }

                                    }}>
                                    {item.hasError == false && (
                                        <Fragment>
                                            <ListItemIcon>
                                                <Badge max={alertsBadgeLimit} badgeContent={item.count} color="secondary" showZero>
                                                    <NotificationsIcon></NotificationsIcon>
                                                </Badge>
                                            </ListItemIcon>
                                            <ListItemText primary={item.name} />
                                        </Fragment>
                                    )}
                                    {item.hasError == true && (
                                        <Fragment>
                                            <ListItemIcon>
                                                <Badge badgeContent={item.count} color="secondary">
                                                    <WarningOutlined></WarningOutlined>
                                                </Badge>
                                            </ListItemIcon>
                                            <ListItemText primary={item.name} secondary={item.err} />
                                        </Fragment>
                                    )}
                                </ListItemButton>
                                <Divider />
                            </Fragment>
                        ))}
                    </List>
                )}


            </Drawer>
        </>
    );
}

export default AlertsView;